import { PositionScenarios } from "../../types";

export const lckScenarios: PositionScenarios = {
  "1": {
    "1": [{ "3": 0, "5": 0 }],
    "2": [{ "4": 0, "5": 1 }],
    "3": [{ "1": 0, "3": 1, "5": 0 }],
    "4": [{ "2": 0, "4": 1, "5": 1 }],
    "5": [{ "2": 1, "4": 1, "5": 1 }],
    "6": [{ "1": 1, "3": 1, "5": 0 }],
    "7": [],
    "8": [],
    "9": [],
    "10": [],
  },
  "2": {
    "1": [
      { "2": 1, "3": 1, "4": 0, "5": 1 },
      { "2": 1, "3": 1, "4": 1 },
      { "2": 1, "3": 0, "5": 1 },
      { "2": 0, "5": 1 },
    ],
    "2": [
      { "3": 1, "4": 0, "5": 0 },
      { "3": 0, "5": 0 },
    ],
    "3": [],
    "4": [{ "2": 0, "3": 1, "4": 1, "5": 0 }],
    "5": [],
    "6": [],
    "7": [],
    "8": [],
    "9": [],
    "10": [],
  },
  "3": {
    "1": [
      { "2": 1, "3": 1, "4": 0, "5": 0 },
      { "2": 0, "3": 1, "5": 0 },
    ],
    "2": [
      { "2": 1, "3": 0, "4": 1, "5": 1 },
      { "2": 1, "3": 1, "4": 1 },
      { "2": 0, "4": 1, "5": 1 },
    ],
    "3": [
      { "1": 0, "2": 1, "3": 0, "4": 0 },
      { "1": 0, "3": 1, "4": 0, "5": 1 },
    ],
    "4": [
      { "2": 0, "3": 0, "4": 1, "5": 0 },
      { "2": 0, "3": 0, "4": 0 },
    ],
    "5": [
      { "1": 1, "2": 1, "3": 0, "4": 0 },
      { "2": 1, "3": 0, "4": 1, "5": 0 },
    ],
    "6": [{ "1": 1, "3": 1, "4": 0, "5": 1 }],
    "7": [],
    "8": [],
    "9": [],
    "10": [],
  },
  "4": {
    "1": [],
    "2": [{ "2": 0, "3": 1, "4": 1, "5": 0 }],
    "3": [
      { "1": 0, "3": 1, "4": 1, "5": 1 },
      { "1": 0, "2": 0, "3": 0 },
    ],
    "4": [
      { "1": 0, "2": 1, "3": 0 },
      { "3": 1, "4": 0 },
    ],
    "5": [{ "2": 1, "3": 1, "4": 1, "5": 0 }],
    "6": [
      { "1": 1, "3": 1, "4": 1, "5": 1 },
      { "1": 1, "3": 0 },
    ],
    "7": [],
    "8": [],
    "9": [],
    "10": [],
  },
  "5": {
    "1": [],
    "2": [],
    "3": [
      { "1": 0, "2": 1, "3": 0, "4": 1 },
      { "1": 1, "2": 0 },
    ],
    "4": [
      { "1": 1, "2": 1, "3": 0 },
      { "2": 1, "3": 1, "4": 1 },
    ],
    "5": [
      { "1": 1, "2": 1, "3": 1, "4": 0 },
      { "1": 0, "2": 1, "4": 0 },
      { "1": 0, "2": 0 },
    ],
    "6": [],
    "7": [],
    "8": [],
    "9": [],
    "10": [],
  },
  "6": {
    "1": [],
    "2": [],
    "3": [{ "1": 1, "2": 1 }],
    "4": [],
    "5": [],
    "6": [{ "1": 0 }],
    "7": [{ "1": 1, "2": 0 }],
    "8": [],
    "9": [],
    "10": [],
  },
};
